// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2m-fL","bigColWidth":"Table_bigColWidth__1LWPm","biggerColWidth":"Table_biggerColWidth__30vBT","row":"Table_row__3Dg71","col":"Table_col__3g1en"};